module.exports = __webpack_public_path__ + "static/media/bg_login.d8725c0e.jpg";